






import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';

@Component
export default class LockChildren extends BaseComponent {
  @Prop(Boolean)
  public value?: boolean;
  @Prop(String)
  public alertTitle?: string;
  @Prop(String)
  public alertMessage?: string;

  public isLocked: boolean = false;

  @Watch('value')
  public onChangeValue(val: boolean): void {
    this.isLocked = val;
  }

  public onClick(): void {
    const updateAction = () => {
      this.isLocked = !this.isLocked;
      this.$emit('input', this.isLocked);
    };

    const title = this.alertTitle || 'Alterar Informação?';
    const message =
      this.alertMessage ||
      'Algumas informações podem ser perdidas na alteração.';

    this.dialog.show(
      'alert',
      title,
      message,
      'Alterar',
      updateAction,
      'Cancelar',
      '',
    );
  }
}
